import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import * as Sentry from '@sentry/react'
import './index.css'
import App from './App.jsx'
import { AuthProvider } from './contexts/AuthContext'

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,

  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],

  // Capture 100% of transactions. Lower to e.g. 0.2 in production to reduce quota usage.
  tracesSampleRate: 1.0,

  // Session Replay: record 10% of normal sessions, 100% of sessions with an error.
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,

  // Tag events with the current Vite mode ("production", "development", etc.)
  environment: import.meta.env.MODE,

  // Only send events in production builds. Remove this line to test locally.
  enabled: import.meta.env.PROD,

  // Filter out known noise so your issue list stays clean.
  ignoreErrors: [
    // ── Network / connectivity ──────────────────────────────────────────────
    'Network Error',
    'Failed to fetch',
    'NetworkError when attempting to fetch resource.',
    'Load failed',
    'The Internet connection appears to be offline.',
    'FetchError',

    // ── Browser extension interference ──────────────────────────────────────
    /^chrome-extension:\/\//,
    /^moz-extension:\/\//,

    // ── Harmless browser quirks ─────────────────────────────────────────────
    'ResizeObserver loop limit exceeded',
    'ResizeObserver loop completed with undelivered notifications.',

    // ── Unhandled promise rejections that are not real errors ───────────────
    'Non-Error promise rejection captured',

    // ── Safari-specific ─────────────────────────────────────────────────────
    'AbortError: Fetch is aborted',
  ],
})

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={<p>Κάτι πήγε στραβά. Παρακαλώ ανανεώστε τη σελίδα.</p>}>
      <AuthProvider>
        <App />
      </AuthProvider>
    </Sentry.ErrorBoundary>
  </StrictMode>,
)
